import { MarkerType } from '@/types/marker.type';
import Image from 'next/image';

interface SubwayInfo {
  city: string;
  line: string;
  color: string;
  viewName: string;
  detail: string;
}

interface Props {
  /** [0]: 도로명 주소 */
  address: string[];
  /** 지도 마커 정보 */
  markers: MarkerType[];
  /** 지번 주소 */
  roadAddress: string;
  /** 교통 수단 위치 설명 (ex: '삼성역 1번 출구에서 385m 도보 5분') */
  /** 지하철 정보 배열 */
  subways?: SubwayInfo[];
}

const BranchAddress = ({ address, roadAddress, subways }: Props) => {
  // 모든 주소 정보가 없으면 섹션 전체를 숨김
  const hasRoadAddress = address && address[0] && address[0].trim();
  const hasLotAddress = roadAddress && roadAddress.trim();
  const hasSubways = subways && subways.length > 0;

  if (!hasRoadAddress && !hasLotAddress && !hasSubways) {
    return null;
  }

  const items: Array<{
    type: string;
    text: string;
    textColor: string;
    borderColor?: string;
    badgeColor?: string;
  }> = [
    {
      type: '도로명',
      text: hasRoadAddress ? roadAddress : '-',
      textColor: '#999999',
      borderColor: '#DDDDDD',
    },
    {
      type: '지번',
      text: hasLotAddress ? address[0] : '-',
      textColor: '#999999',
      borderColor: '#DDDDDD',
    },
  ];

  // 지하철 정보가 있으면 추가
  if (hasSubways) {
    subways.forEach((subway) => {
      items.push({
        type: subway.line, // "2호선" 전체 표시
        text: subway.detail,
        textColor: '#ffffff',
        badgeColor: subway.color,
      });
    });
  }

  return (
    <div className="desktop:flex desktop:pb-9 gap-4 pb-7">
      <div className="desktop:w-[100px] desktop:items-start desktop:pb-5 flex pb-4">
        <Image
          alt="매장안내"
          src="/images/icons/icon_map_pin_2.svg"
          width={20}
          height={20}
        />
        <span className="typo-20 text-level-3 pl-2 font-bold">위치</span>
      </div>
      {/* 주소 리스트 */}
      <ul className="desktop:pl-[24px] flex flex-col gap-3">
        {items.map((item, idx) => (
          <li key={idx} className="flex items-center">
            <span
              className="typo-12 w-min-[50px] mr-2 inline-flex h-[18px] flex-shrink-0 items-center justify-center rounded-[4px] px-1 font-medium"
              style={{
                color: item.textColor,
                backgroundColor: item.badgeColor,
                border: item.borderColor
                  ? `1px solid ${item.borderColor}`
                  : undefined,
              }}
            >
              {item.type}
            </span>
            <span className="typo-15 text-level-4 desktop:typo-18 font-medium">
              {item.text}
            </span>
          </li>
        ))}
      </ul>
      {/* <MapDetail
        key={JSON.stringify(markers)}
        markers={markers}
        zoom={16}
        className="desktop:h-[248px] mb-5 h-[190px] w-full rounded-2xl"
      /> */}
    </div>
  );
};

export default BranchAddress;
